import React from 'react';
import ReactDOM from 'react-dom';
import Rodal from 'rodal';

export default function WrappedRodal(props) {
  return ReactDOM.createPortal(<Rodal {...props} />, document.getElementById('modalsRoot'));
}
